import TagsPage from './TagsPage';
export default TagsPage;
